const useCookieDeclaration = () => {
  const cookieDeclarationScriptIsLoaded = () => {
    // Select the script element by ID
    const script = document.getElementById('CookieDeclaration');

    if (script) {
      const scriptLoadTimeout = setTimeout(function() {
        const cookieDeclarationInformation = document.querySelector("#cookie-declaration-information") as HTMLElement;

        console.error('Error: Script loading timed out. It might be blocked.');

        if (cookieDeclarationInformation) {
          cookieDeclarationInformation.hidden = false;
        }
      }, 3000);

      script.addEventListener('load', function() {
        clearTimeout(scriptLoadTimeout);
      });

      script.addEventListener('error', function() {
        clearTimeout(scriptLoadTimeout);
        console.error('Error: Script failed to load.');
      });
    } else {
      console.error('Script element with ID "CookieDeclaration" not found.');
    }
  };

  // Init
  cookieDeclarationScriptIsLoaded();
};
document.addEventListener('DOMContentLoaded', function() {
  useCookieDeclaration();
});